// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: configd/fabrics.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  NodeRole,
  nodeRoleFromJSON,
  nodeRoleToJSON,
  NodeType,
  nodeTypeFromJSON,
  nodeTypeToJSON,
} from "../models/fabric";
import { OsType, osTypeFromJSON, osTypeToJSON } from "../models/global";

export const protobufPackage = "configd";

/**
 * A Device is a physical device such as a Cisco 6000 switch managed by Cisco Nexus Hyperfabric
 * that can be bound to a node in a fabric.
 */
export interface Device {
  /** The device identifier of the device. */
  deviceId: string;
  /** The unique identifier of the node to which the device is bound. */
  nodeId: string;
  /** The serial number of the device. */
  serialNumber: string;
  /** The model name of the device. */
  modelName: string;
  /** The unique identifier of the fabric of the node to which the device is bound. */
  fabricId: string;
  /** A list of roles associated with the node to which the device is bound. */
  roles: NodeRole[];
  /** The name of the device. */
  name: string;
  /** The type of the node to which the device is bound. */
  nodeType: NodeType;
  /** The name of the fabric that the devices belongs to. */
  fabricName: string;
}

export interface GetDeviceInventoriesRequest {
  deviceId: string;
}

export interface GetDeviceInventoriesResponse {
  device: Device | undefined;
}

export interface AssignUnknownDeviceRequest {
  deviceId: string;
  serialNum: string;
  modelName: string;
  osType: OsType;
  monitored: boolean;
}

export interface GetParkinglotDeviceAssignmentRequest {
  deviceId: string;
}

export interface GetParkinglotDeviceAssignmentResponse {
  /** parkinglot org id */
  orgId: string;
  /** parking lot fabricId */
  fabricId: string;
  /** flag to report if device is in inventory database or not */
  isKnownDevice: boolean;
}

export interface EnsureParkingLotFabricsRequest {
  orgId: string;
}

export interface EnsureParkingLotFabricsResponse {
  /** parking lot fabric external ids */
  fabricIds: string[];
}

function createBaseDevice(): Device {
  return {
    deviceId: "",
    nodeId: "",
    serialNumber: "",
    modelName: "",
    fabricId: "",
    roles: [],
    name: "",
    nodeType: 0,
    fabricName: "",
  };
}

export const Device: MessageFns<Device> = {
  encode(message: Device, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.serialNumber !== "") {
      writer.uint32(26).string(message.serialNumber);
    }
    if (message.modelName !== "") {
      writer.uint32(34).string(message.modelName);
    }
    if (message.fabricId !== "") {
      writer.uint32(42).string(message.fabricId);
    }
    writer.uint32(66).fork();
    for (const v of message.roles) {
      writer.int32(v);
    }
    writer.join();
    if (message.name !== "") {
      writer.uint32(74).string(message.name);
    }
    if (message.nodeType !== 0) {
      writer.uint32(80).int32(message.nodeType);
    }
    if (message.fabricName !== "") {
      writer.uint32(90).string(message.fabricName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Device {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 8: {
          if (tag === 64) {
            message.roles.push(reader.int32() as any);

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.roles.push(reader.int32() as any);
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.nodeType = reader.int32() as any;
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Device {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      roles: globalThis.Array.isArray(object?.roles) ? object.roles.map((e: any) => nodeRoleFromJSON(e)) : [],
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      nodeType: isSet(object.nodeType) ? nodeTypeFromJSON(object.nodeType) : 0,
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
    };
  },

  toJSON(message: Device): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.roles?.length) {
      obj.roles = message.roles.map((e) => nodeRoleToJSON(e));
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.nodeType !== 0) {
      obj.nodeType = nodeTypeToJSON(message.nodeType);
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Device>, I>>(base?: I): Device {
    return Device.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Device>, I>>(object: I): Device {
    const message = createBaseDevice();
    message.deviceId = object.deviceId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.modelName = object.modelName ?? "";
    message.fabricId = object.fabricId ?? "";
    message.roles = object.roles?.map((e) => e) || [];
    message.name = object.name ?? "";
    message.nodeType = object.nodeType ?? 0;
    message.fabricName = object.fabricName ?? "";
    return message;
  },
};

function createBaseGetDeviceInventoriesRequest(): GetDeviceInventoriesRequest {
  return { deviceId: "" };
}

export const GetDeviceInventoriesRequest: MessageFns<GetDeviceInventoriesRequest> = {
  encode(message: GetDeviceInventoriesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDeviceInventoriesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDeviceInventoriesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDeviceInventoriesRequest {
    return { deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "" };
  },

  toJSON(message: GetDeviceInventoriesRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDeviceInventoriesRequest>, I>>(base?: I): GetDeviceInventoriesRequest {
    return GetDeviceInventoriesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDeviceInventoriesRequest>, I>>(object: I): GetDeviceInventoriesRequest {
    const message = createBaseGetDeviceInventoriesRequest();
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseGetDeviceInventoriesResponse(): GetDeviceInventoriesResponse {
  return { device: undefined };
}

export const GetDeviceInventoriesResponse: MessageFns<GetDeviceInventoriesResponse> = {
  encode(message: GetDeviceInventoriesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.device !== undefined) {
      Device.encode(message.device, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetDeviceInventoriesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetDeviceInventoriesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.device = Device.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetDeviceInventoriesResponse {
    return { device: isSet(object.device) ? Device.fromJSON(object.device) : undefined };
  },

  toJSON(message: GetDeviceInventoriesResponse): unknown {
    const obj: any = {};
    if (message.device !== undefined) {
      obj.device = Device.toJSON(message.device);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetDeviceInventoriesResponse>, I>>(base?: I): GetDeviceInventoriesResponse {
    return GetDeviceInventoriesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetDeviceInventoriesResponse>, I>>(object: I): GetDeviceInventoriesResponse {
    const message = createBaseGetDeviceInventoriesResponse();
    message.device = (object.device !== undefined && object.device !== null)
      ? Device.fromPartial(object.device)
      : undefined;
    return message;
  },
};

function createBaseAssignUnknownDeviceRequest(): AssignUnknownDeviceRequest {
  return { deviceId: "", serialNum: "", modelName: "", osType: 0, monitored: false };
}

export const AssignUnknownDeviceRequest: MessageFns<AssignUnknownDeviceRequest> = {
  encode(message: AssignUnknownDeviceRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.serialNum !== "") {
      writer.uint32(18).string(message.serialNum);
    }
    if (message.modelName !== "") {
      writer.uint32(26).string(message.modelName);
    }
    if (message.osType !== 0) {
      writer.uint32(32).int32(message.osType);
    }
    if (message.monitored !== false) {
      writer.uint32(40).bool(message.monitored);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignUnknownDeviceRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignUnknownDeviceRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serialNum = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.osType = reader.int32() as any;
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.monitored = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignUnknownDeviceRequest {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      serialNum: isSet(object.serialNum) ? globalThis.String(object.serialNum) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      osType: isSet(object.osType) ? osTypeFromJSON(object.osType) : 0,
      monitored: isSet(object.monitored) ? globalThis.Boolean(object.monitored) : false,
    };
  },

  toJSON(message: AssignUnknownDeviceRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.serialNum !== "") {
      obj.serialNum = message.serialNum;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.osType !== 0) {
      obj.osType = osTypeToJSON(message.osType);
    }
    if (message.monitored !== false) {
      obj.monitored = message.monitored;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignUnknownDeviceRequest>, I>>(base?: I): AssignUnknownDeviceRequest {
    return AssignUnknownDeviceRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignUnknownDeviceRequest>, I>>(object: I): AssignUnknownDeviceRequest {
    const message = createBaseAssignUnknownDeviceRequest();
    message.deviceId = object.deviceId ?? "";
    message.serialNum = object.serialNum ?? "";
    message.modelName = object.modelName ?? "";
    message.osType = object.osType ?? 0;
    message.monitored = object.monitored ?? false;
    return message;
  },
};

function createBaseGetParkinglotDeviceAssignmentRequest(): GetParkinglotDeviceAssignmentRequest {
  return { deviceId: "" };
}

export const GetParkinglotDeviceAssignmentRequest: MessageFns<GetParkinglotDeviceAssignmentRequest> = {
  encode(message: GetParkinglotDeviceAssignmentRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetParkinglotDeviceAssignmentRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetParkinglotDeviceAssignmentRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetParkinglotDeviceAssignmentRequest {
    return { deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "" };
  },

  toJSON(message: GetParkinglotDeviceAssignmentRequest): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetParkinglotDeviceAssignmentRequest>, I>>(
    base?: I,
  ): GetParkinglotDeviceAssignmentRequest {
    return GetParkinglotDeviceAssignmentRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetParkinglotDeviceAssignmentRequest>, I>>(
    object: I,
  ): GetParkinglotDeviceAssignmentRequest {
    const message = createBaseGetParkinglotDeviceAssignmentRequest();
    message.deviceId = object.deviceId ?? "";
    return message;
  },
};

function createBaseGetParkinglotDeviceAssignmentResponse(): GetParkinglotDeviceAssignmentResponse {
  return { orgId: "", fabricId: "", isKnownDevice: false };
}

export const GetParkinglotDeviceAssignmentResponse: MessageFns<GetParkinglotDeviceAssignmentResponse> = {
  encode(message: GetParkinglotDeviceAssignmentResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    if (message.fabricId !== "") {
      writer.uint32(18).string(message.fabricId);
    }
    if (message.isKnownDevice !== false) {
      writer.uint32(24).bool(message.isKnownDevice);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetParkinglotDeviceAssignmentResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetParkinglotDeviceAssignmentResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isKnownDevice = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetParkinglotDeviceAssignmentResponse {
    return {
      orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      isKnownDevice: isSet(object.isKnownDevice) ? globalThis.Boolean(object.isKnownDevice) : false,
    };
  },

  toJSON(message: GetParkinglotDeviceAssignmentResponse): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.isKnownDevice !== false) {
      obj.isKnownDevice = message.isKnownDevice;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetParkinglotDeviceAssignmentResponse>, I>>(
    base?: I,
  ): GetParkinglotDeviceAssignmentResponse {
    return GetParkinglotDeviceAssignmentResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetParkinglotDeviceAssignmentResponse>, I>>(
    object: I,
  ): GetParkinglotDeviceAssignmentResponse {
    const message = createBaseGetParkinglotDeviceAssignmentResponse();
    message.orgId = object.orgId ?? "";
    message.fabricId = object.fabricId ?? "";
    message.isKnownDevice = object.isKnownDevice ?? false;
    return message;
  },
};

function createBaseEnsureParkingLotFabricsRequest(): EnsureParkingLotFabricsRequest {
  return { orgId: "" };
}

export const EnsureParkingLotFabricsRequest: MessageFns<EnsureParkingLotFabricsRequest> = {
  encode(message: EnsureParkingLotFabricsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.orgId !== "") {
      writer.uint32(10).string(message.orgId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnsureParkingLotFabricsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnsureParkingLotFabricsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.orgId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnsureParkingLotFabricsRequest {
    return { orgId: isSet(object.orgId) ? globalThis.String(object.orgId) : "" };
  },

  toJSON(message: EnsureParkingLotFabricsRequest): unknown {
    const obj: any = {};
    if (message.orgId !== "") {
      obj.orgId = message.orgId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnsureParkingLotFabricsRequest>, I>>(base?: I): EnsureParkingLotFabricsRequest {
    return EnsureParkingLotFabricsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnsureParkingLotFabricsRequest>, I>>(
    object: I,
  ): EnsureParkingLotFabricsRequest {
    const message = createBaseEnsureParkingLotFabricsRequest();
    message.orgId = object.orgId ?? "";
    return message;
  },
};

function createBaseEnsureParkingLotFabricsResponse(): EnsureParkingLotFabricsResponse {
  return { fabricIds: [] };
}

export const EnsureParkingLotFabricsResponse: MessageFns<EnsureParkingLotFabricsResponse> = {
  encode(message: EnsureParkingLotFabricsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.fabricIds) {
      writer.uint32(10).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EnsureParkingLotFabricsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEnsureParkingLotFabricsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.fabricIds.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EnsureParkingLotFabricsResponse {
    return {
      fabricIds: globalThis.Array.isArray(object?.fabricIds)
        ? object.fabricIds.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: EnsureParkingLotFabricsResponse): unknown {
    const obj: any = {};
    if (message.fabricIds?.length) {
      obj.fabricIds = message.fabricIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<EnsureParkingLotFabricsResponse>, I>>(base?: I): EnsureParkingLotFabricsResponse {
    return EnsureParkingLotFabricsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<EnsureParkingLotFabricsResponse>, I>>(
    object: I,
  ): EnsureParkingLotFabricsResponse {
    const message = createBaseEnsureParkingLotFabricsResponse();
    message.fabricIds = object.fabricIds?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
